
export default function AdvantagesSection() {
  const advantages = [
    {
      icon: "ri-trophy-line",
      title: "线上验证爆品",
      description: "所有产品均经过线上市场验证，销量数据真实可靠，降低合作风险",
      stats: "月销10万+"
    },
    {
      icon: "ri-medal-line",
      title: "5.0满分体验",
      description: "各大平台店铺体验分均为满分5.0，专业的运营团队保障服务质量",
      stats: "体验分5.0"
    },
    {
      icon: "ri-arrow-up-line",
      title: "转化率高",
      description: "平均转化率达到15%，远超行业平均水平，确保合作伙伴收益最大化",
      stats: "转化率15%"
    },
    {
      icon: "ri-price-tag-3-line",
      title: "性价比高",
      description: "直接工厂供货，省去中间环节，为合作伙伴提供最具竞争力的价格优势",
      stats: "成本降低40%"
    },
    {
      icon: "ri-refresh-line",
      title: "退货率低",
      description: "严格的品质控制体系，退货率控制在2%以内，减少售后困扰",
      stats: "退货率&lt;2%"
    },
    {
      icon: "ri-customer-service-2-line",
      title: "售后服务好",
      description: "7×24小时客服支持，专业售后团队，为每一位客户提供贴心服务",
      stats: "24小时响应"
    },
    {
      icon: "ri-truck-line",
      title: "24小时发货",
      description: "强大的供应链体系，承诺24小时内发货，快速响应市场需求",
      stats: "次日达95%"
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "佣金高",
      description: "行业领先的佣金比例，最高可达35%，让合作伙伴获得丰厚回报",
      stats: "佣金高达35%"
    },
    {
      icon: "ri-star-line",
      title: "好评率高",
      description: "产品好评率超98%，客户满意度极高，为合作伙伴建立良好口碑",
      stats: "好评率98%+"
    }
  ];

  return (
    <section id="advantages-section" className="py-20 bg-gradient-to-br from-orange-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            我们的优势
          </h2>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mb-6"></div>
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            九大核心优势，为合作伙伴提供全方位保障，确保合作成功
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {advantages.map((advantage, index) => (
            <div key={index} className="bg-white rounded-xl p-4 sm:p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
              <div className="text-center">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#cc9966] to-[#b8865a] rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-5 md:mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${advantage.icon} text-lg sm:text-xl md:text-2xl text-white`}></i>
                </div>
                
                <h3 className="text-sm sm:text-lg md:text-xl font-bold text-[#663333] mb-3 sm:mb-4">
                  {advantage.title}
                </h3>
                
                <p className="text-xs sm:text-base text-gray-600 mb-4 sm:mb-5 md:mb-6 leading-relaxed">
                  {advantage.description}
                </p>
                
                <div className="bg-gradient-to-r from-[#663333] to-[#552222] text-white px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold">
                  {advantage.stats}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 数据展示 */}
        <div className="mt-16 bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 text-center">
            <div>
              <div className="text-xl sm:text-3xl font-bold text-[#663333] mb-2">98.5%</div>
              <div className="text-xs sm:text-base text-gray-600">客户满意度</div>
            </div>
            <div>
              <div className="text-xl sm:text-3xl font-bold text-[#663333] mb-2">24h</div>
              <div className="text-xs sm:text-base text-gray-600">发货时效</div>
            </div>
            <div>
              <div className="text-xl sm:text-3xl font-bold text-[#663333] mb-2">35%</div>
              <div className="text-xs sm:text-base text-gray-600">最高佣金</div>
            </div>
            <div>
              <div className="text-xl sm:text-3xl font-bold text-[#663333] mb-2">500+</div>
              <div className="text-xs sm:text-base text-gray-600">合作伙伴</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
